import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

function TextTranslate ({name, fallback = 'n/a', textOnly, className="", currentLanguage, translations, ...props}) {
    if(
        (!translations || !translations[name] || !translations[name][currentLanguage.id])
        && !textOnly
    ) {
        return <span className={className} dangerouslySetInnerHTML={{__html:fallback}} />
    }

    // If no translation is found return fallback
    if(!translations || !translations[name] || !translations[name][currentLanguage.id]) {
        return fallback
    }

    // If textOnly is false return dangerouslySetInnerHTML (default case)
    if (!textOnly) {
        return <span className={className} dangerouslySetInnerHTML={{__html:translations[name][currentLanguage.id]}} />
    }

    // If textOnly is true, return text translation only
    if (textOnly) {
        return translations[name][currentLanguage.id]
    }
}

export function TextTranslateString (name, fallback = "", currentLanguage, translations) {
    
    if(!translations || !translations[name] || !translations[name][currentLanguage.id]) {
        return fallback
    }

    return translations[name][currentLanguage.id]
}

export function TranslateCMS ({location, transId = 0, field = '', currentLanguage}) {

    // Translation not loaded yet
    if(!location?.length) {
        return (<>Loading...</>);
    }

    // Translation found
    if(!!location?.[transId]?.translations?.[field]?.[currentLanguage.id]) {
        return location[transId].translations[field][currentLanguage.id]
    }

    // No translation or language found, load default
    if(!!location?.[transId]?.[field] || !currentLanguage) {
        return location[transId][field];
    }

    // No translation or default found
    return (<>No translation found.</>)
}

const mapStateToProps = (state) => ({
    currentLanguage: state.translations?.currentLanguage,
	translations: state.translations?.translations
});

export default connect(mapStateToProps)(withRouter(TextTranslate));
